import styled from "styled-components";
import { device } from "../device";

export const BackendGridContainer = styled.div`
    box-sizing: border-box;
    max-width: 1440px;
    display: grid;
    grid-gap: 15px;
    padding: 0;
    margin: 0;
    grid-template-columns: repeat(12, 1fr);  

    @media ${device.tablet} {
        grid-gap: 20px;
        padding: 0;
    }
    @media ${device.laptop} {
        grid-gap: 25px;
        padding: 0;
    }
`;

export interface GridProps {
    span: number;
}

export const BackendGridItem = styled.div<GridProps>`
    grid-column: span 12;
    border-radius: 20px;
    @media ${device.tablet} {
        grid-column: span ${(props) => props.span};
        border-radius: 30px;
    }
    background-color: #FFFFFF;
    border: 1px solid #EAEAEA;
    display: flex;
    flex-direction: column;
    position: relative;
    box-sizing: border-box;
    overflow: hidden;
    z-index: 0;
`;